import React, { useEffect, useState } from "react";
import NavigationComponent from "../../../components/NavigationComponent";
import Header from "../../../components/Header";
import { popUpsGetAll } from "../../../adminApi/popUps";
import { toast } from "react-toastify";
import axios from "axios";
import { getSectionCMS } from "../../../adminApi/mastermenu";
import FadeLoader from "react-spinners/FadeLoader";
const PopUp = () => {
  const token = localStorage.getItem("access_token");
  const [popUps, setPopUps] = useState();
  const [popUpDesc, setPopUpDesc] = useState([]);
  const [popUpImage, setPopUpImage] = useState();
  const [selectedDescImage, setSelectedDescImage] = useState();
  const [sectionData, setSectionData] = useState([]);
  const [popHeaderDesc, setPopHeaderDesc] = useState();
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    getAllPopUpData();
    getPopUpHeaderImage();
  }, []);

  const getPopUpHeaderImage = async () => {
    try {
      setShowLoader(false);
      const section = await getSectionCMS(token, 182);
      setSectionData(section);
      setPopHeaderDesc(section?.[0]?.descriptionSection?.description);
      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
    }
  };
  const getAllPopUpData = async () => {
    try {
      const response = await popUpsGetAll();
      setPopUps(response?.data?.data);
      setPopUpDesc((prevState) => [
        ...prevState,
        ...response?.data?.data?.map((item) => item?.description),
      ]);
    } catch (error) {}
  };

  const handleFileChange = async (e) => {
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        setSelectedDescImage(file?.name);
        const reader = new FileReader();
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;
        const img = new Image();
        img.src = reader.result;

        img.onload = async () => {
          // Set the desired height and width
          const desiredHeight = 412;
          const desiredWidth = 635;

          // Create a canvas element to draw the image with the new dimensions
          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL("image/jpeg");
          // You can also use 'image/png' for PNG format
          setPopUpImage(resizedImage);
        };
      }
    } catch (error) {
      toast.error(error);
    }
  };
  const popUpSubmitHandler = async (popUpId, index) => {
    try {
      let data;
      if (popUpImage !== undefined || popUpImage !== null) {
        data = {
          pop_ups_id: popUpId,
          description: popUpDesc?.[index],
          image: popUpImage,
        };
      } else {
        data = {
          pop_ups_id: popUpId,
          description: popUpDesc?.[index],
        };
      }
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/pop_ups`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status === 201 || response?.status === 200) {
        toast.success(`Pop Ups updated successfully`);
        getAllPopUpData();
        setSelectedDescImage();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const popUpHeaderImage = async (e, id) => {
    const sectionId = parseInt(id, 10);
    e.preventDefault();

    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        // setSelectedHeaderFile(file?.name);
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = async () => {
          // Set the desired height and width
          const desiredHeight = 780;
          const desiredWidth = 1920;

          // Create a canvas element to draw the image with the new dimensions
          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const convertedFile = {
            image: canvas.toDataURL("image/jpeg"), // Use 'image/jpeg' for JPEG format
          };

          const convertedFileName = {
            name: file.name,
          };

          //   setImages([convertedFile]);
          //   setFormData({ ...formData, file: convertedFileName });

          const postData = {
            image: convertedFile.image,
            section_id: sectionId,
          };

          // Perform the API call here
          const token = localStorage.getItem("access_token");
          try {
            const response = await axios.post(
              process.env.REACT_APP_BASE_URL + `/admin/imageupload-cms`,
              postData,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response?.status === 200) {
              toast.success("Image uploaded successfully.");
              await getPopUpHeaderImage();
            }
          } catch (error) {
            return error;
          }
        };
      }
    } catch (error) {
      console.error(error);
    }
  };

  const popUpDescriptionHandler = async (id) => {
    try {
      const postData = {
        description: popHeaderDesc,
        section_id: id,
      };
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/description-cms`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status === 201 || response?.status === 200) {
        toast.success("Pop up description added successfully.");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const popUpDescHandler = (value, index) => {
    setPopUpDesc((prevState) => {
      const newState = [...prevState];
      newState[index] = value;
      return newState;
    });
  };
  return (
    <>
      <div className="container--component">
        <div className="container--grid">
          <NavigationComponent />
          <div className="Adminpage">
            <Header title="POP UPS" subTitle="(Manage Pop Ups)" />
            <div class="accordion__card__body" style={{ display: "block" }}>
              <h3 class="title">
                Note: Compress back after completion of activity
              </h3>

              <div class="commonList">
                <div class="commonList__row">
                  {sectionData?.map(
                    (item) =>
                      item?.section_name === "Header" && (
                        <div class="commonList__row__col">
                          <h4 class="label">Header Image:</h4>
                          <div class="cardbox">
                            <div class="browseBox">
                              <div class="browseFile">
                                <div class="browseFile__icon">
                                  <svg
                                    width="33"
                                    height="33"
                                    viewBox="0 0 33 33"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                  >
                                    <rect
                                      x="0.180664"
                                      width="32.53"
                                      height="32.53"
                                      fill="url(#pattern0)"
                                    />
                                    <defs>
                                      <pattern
                                        id="pattern0"
                                        patternContentUnits="objectBoundingBox"
                                        width="1"
                                        height="1"
                                      >
                                        <image xlinkHref="data:image/png;base64,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" />
                                      </pattern>
                                    </defs>
                                  </svg>
                                </div>
                                <h4 class="browseFile__text">
                                  Drag files to upload
                                </h4>
                                <p class="browseFile__ortext">or</p>
                                <input
                                  class="hiddenInput"
                                  id="BrowseFiles"
                                  type="file"
                                  onChange={(e) =>
                                    popUpHeaderImage(e, item?.id)
                                  }
                                />
                                {/* <h6>{selectedHeaderFile}</h6> */}
                                <label for="BrowseFiles" class="browseBtn">
                                  Browse Files
                                </label>
                                <div class="browseFileData">
                                  <p class="browseFileData__text">
                                    Max File Size: <strong>10 MB</strong>
                                  </p>
                                  <p class="browseFileData__text">
                                    Supported file type:{" "}
                                    <strong>JPG,PNG,SVG</strong>
                                  </p>
                                </div>
                                <div>
                                  {showLoader ? (
                                    <FadeLoader
                                      color="#5497C7"
                                      height={21}
                                      margin={1}
                                    />
                                  ) : (
                                    <img
                                      src={item?.imageSection?.image}
                                      alt=""
                                      className="prevImage"
                                    />
                                  )}
                                </div>
                              </div>
                              <div class="adminbutton__group">
                                {/* <button class="adminbtn adminbtn-primary">
                                                        Save
                                                    </button> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
                </div>
                {sectionData?.map(
                  (item) =>
                    item?.section_name === "POP UPS Description" && (
                      <div className="commonList__row">
                        <h4 class="label">Description:</h4>
                        <div className="cardbox">
                          <div class="adminform__group">
                            <textarea
                              class="adminform__textarea"
                              placeholder="write the contents here!"
                              value={popHeaderDesc}
                              onChange={(e) => setPopHeaderDesc(e.target.value)}
                            ></textarea>
                          </div>
                          <button
                            class="admibtn admibtn-primary"
                            onClick={() => popUpDescriptionHandler(item?.id)}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    )
                )}
                <hr />
                {/* ===================POP UP IMAGE CONTAINER================== */}

                <div className="commonList__row commonList__row__pop_flexwrap">
                  {popUps?.map((item, index) => (
                    <div class="commonList__row__col">
                      <div class="commonList__row__col">
                        <h4 class="label">Pop Image:</h4>
                        <div class="cardbox">
                          <div class="browseBox">
                            <div class="browseFile">
                              <div class="browseFile__icon">
                                <svg
                                  width="33"
                                  height="33"
                                  viewBox="0 0 33 33"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                  <rect
                                    x="0.180664"
                                    width="32.53"
                                    height="32.53"
                                    fill="url(#pattern0)"
                                  />
                                  <defs>
                                    <pattern
                                      id="pattern0"
                                      patternContentUnits="objectBoundingBox"
                                      width="1"
                                      height="1"
                                    >
                                      <image xlinkHref="data:image/png;base64,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" />
                                    </pattern>
                                  </defs>
                                </svg>
                              </div>
                              <h4 class="browseFile__text">
                                Drag files to upload
                              </h4>
                              <p class="browseFile__ortext">or</p>
                              <input
                                class="hiddenInput"
                                id="BrowseFiles2"
                                type="file"
                                onChange={(e) => handleFileChange(e, item?.id)}
                              />

                              <label for="BrowseFiles2" class="browseBtn">
                                Browse Files
                              </label>
                              <h6>{selectedDescImage}</h6>
                              <div class="browseFileData">
                                <p class="browseFileData__text">
                                  Max File Size: <strong>10 MB</strong>
                                </p>
                                <p class="browseFileData__text">
                                  Supported file type:{" "}
                                  <strong>JPG,PNG,SVG</strong>
                                </p>
                              </div>
                              <div>
                                <img
                                  src={item?.image}
                                  alt=""
                                  className="prevImage"
                                />
                              </div>
                            </div>
                            {/* <div class="adminbutton__group">
                                                        <button class="adminbtn adminbtn-primary">
                                                            Save
                                                        </button>
                                                    </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="cardbox">
                        <div class="adminform__group ">
                          <textarea
                            class="adminform__textarea popUp_text_area_container"
                            placeholder="write the contents here!"
                            value={popUpDesc?.[index]}
                            onChange={(e) =>
                              popUpDescHandler(e.target.value, index)
                            }
                          ></textarea>
                        </div>
                        <button
                          class="admibtn admibtn-primary"
                          onClick={() => popUpSubmitHandler(item?.id, index)}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUp;
